import React from 'react';
import AndrewKasper from '../assets/img/AndrewKasper.png';

function HomeView() {
    return (
        <section
            className="hero container"
            id="home"
            aria-labelledby="hero-title"
            tabIndex="-1"
        >
            <div className="hero-copy">
                <p className="eyebrow">
                    Full stack engineer & UX designer
                </p>
                <h1 id="hero-title">
                    Complex systems.
                    <br />
                    <em>Clear experiences.</em>
                </h1>
                <p className="hero-intro">
                    I’m Andrew. I bring design and engineering
                    together to build business applications that
                    people can actually enjoy using.
                </p>
                <div className="hero-actions">
                    <a className="button button-primary" href="#work">
                        Explore my work{' '}
                        <span aria-hidden="true">↗</span>
                    </a>
                    <a
                        className="text-link"
                        href="/data/Andrew-Kasper-Resume.pdf"
                        target="_blank"
                        rel="noreferrer"
                    >
                        View résumé <span aria-hidden="true">↗</span>
                        <span className="sr-only">
                            {' '}
                            (PDF, opens in a new tab)
                        </span>
                    </a>
                </div>
                <p className="hero-footnote">
                    From the first sketch to the production code.
                </p>
            </div>
            <figure className="portrait">
                <span className="portrait-orbit" aria-hidden="true" />
                <span className="portrait-cross" aria-hidden="true">
                    +
                </span>
                <img
                    src={AndrewKasper}
                    alt="Andrew Kasper"
                    width="2234"
                    height="3200"
                />
                <figcaption>
                    <span
                        className="portrait-dot"
                        aria-hidden="true"
                    />
                    <span>Engineer. Designer. Maker.</span>
                </figcaption>
            </figure>
            <div className="experience-strip">
                <p>
                    <span>THE WORK</span>Enterprise platforms &
                    everyday tools
                </p>
                <p>
                    <span>THE TOOLKIT</span>React, Python & Node.js
                </p>
                <p>
                    <span>THE APPROACH</span>Thoughtful design.
                    Practical engineering.
                </p>
            </div>
        </section>
    );
}

export default HomeView;
